var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ConformityCheckListHeaderButton", {
        ref: "conformityButton",
        on: { click: _vm.toggleCheckList }
      }),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          staticClass: "conformity-popover",
          attrs: {
            isVisible: _vm.isVisible,
            triggerRef: "conformityButton",
            placement: "bottom"
          },
          on: {
            close: function($event) {
              _vm.isVisible = false
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "conformity-popover__wrapper" },
            [
              _c(
                "h3",
                {
                  staticClass:
                    "conformity-popover__title typographies-heading-h3"
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.$t.__("eInvoicing.conformityCheckListHeader.title")
                      ) +
                      "\n            "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "conformity-popover__introduction typographies-paragraph-medium-regular"
                },
                [
                  _c("img", {
                    attrs: {
                      src:
                        "/ressources/logged/img/illustrations/invoicing-signature-blue.svg",
                      alt: _vm.$t.__(
                        "eInvoicing.conformityCheckListHeader.title"
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "\n                    " +
                        _vm._s(
                          _vm.$t.__(
                            "eInvoicing.conformityCheckListHeader.description"
                          )
                        ) +
                        "\n                "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("CheckList", {
                staticClass: "conformity-popover__checklist",
                attrs: { items: _vm.checkListItems, loading: _vm.isLoading }
              }),
              _vm._v(" "),
              _c("CompassLink", {
                attrs: {
                  label: _vm.$t.__(
                    "eInvoicing.conformityCheckListHeader.link.label"
                  ),
                  size: "small",
                  link:
                    "https://help.sellsy.com/fr/collections/14117844-facturation-electronique",
                  target: "_blank"
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }